import { useCallback, useState } from "react";

export function useModalData<InData>() {
	const [shown, setShown] = useState(false);
	const [data, setData] = useState<InData | null>(null);
	const [openCount, setOpenCount] = useState(0);

	const open = useCallback((inData: InData) => {
		setData(inData);
		setShown(true);
		setOpenCount((prev) => prev + 1);
	}, []);
	const close = useCallback(() => {
		setShown(false);
		setData(null);
	}, []);

	const openedKey = useCallback(
		(id: string) => {
			return `${id}-${openCount}`;
		},
		[openCount],
	);

	return { shown, data, open, close, openedKey };
}
export function useModalVoid() {
	const [shown, setShown] = useState(false);
	const [openCount, setOpenCount] = useState(0);

	const open = useCallback(() => {
		setShown(true);
		setOpenCount((prev) => prev + 1);
	}, []);
	const close = useCallback(() => {
		setShown(false);
	}, []);

	const openedKey = useCallback(
		(id: string) => {
			return `${id}-${openCount}`;
		},
		[openCount],
	);

	return { shown, open, close, openedKey };
}

export interface ModalPropsVoid {
	shown: boolean;
	onClose: () => void;
}
export interface ModalPropsData<InData> extends ModalPropsVoid {
	data: InData | null;
}
